import { 
  User, Shield, Settings, FileText, BarChart3, Users, Package, Receipt,
  LayoutDashboard, Wrench, TrendingUp, Activity, ShieldCheck, CreditCard, GitBranch, Zap, HeartPulse
} from 'lucide-react'

export interface AdminNavigationItem {
  name: string
  href: string
  icon: any
  // RBAC fields
  requiredPermissions?: string[]        // Required permissions (OR logic)
  requiredPermissionsAll?: string[]     // Required permissions (AND logic)
  requiredRole?: string[]               // Required roles
  accountType?: 'admin' | 'system'      // Required account type
  // Collapsible sub-items
  children?: AdminNavigationItem[]
}

export interface AdminNavigationSection {
  title: string
  items: AdminNavigationItem[]
  // RBAC fields for entire section
  requiredPermissions?: string[]
  accountType?: 'admin' | 'system'
}

export const adminNavigation: AdminNavigationSection[] = [
  {
    title: "จัดการระบบ",
    accountType: "admin",
    items: [
      { 
        name: "แดชบอร์ด", 
        href: "/admin/dashboard",
        icon: BarChart3,
        requiredPermissions: ["admin:manage"],
        accountType: "admin",
        children: [
          {
            name: "ภาพรวมผู้บริหาร",
            href: "/admin/dashboard",
            icon: BarChart3,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "ภาพรวมการดำเนินงาน",
            href: "/admin/operations",
            icon: LayoutDashboard,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "ประสิทธิภาพทางเทคนิค",
            href: "/admin/technical",
            icon: Wrench,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "สถานะ API ธนาคาร",
            href: "/admin/bank-health",
            icon: HeartPulse,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "การตลาดและการเติบโต",
            href: "/admin/marketing",
            icon: TrendingUp,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
        ],
      },
      { 
        name: "จัดการ KYC", 
        href: "/admin/kyc", 
        icon: User,
        requiredPermissions: ["admin:manage", "kyc:approve", "kyc:reject"],
        accountType: "admin"
      },
      { 
        name: "จัดการแพ็กเกจ", 
        href: "/admin/packages", 
        icon: Package,
        requiredPermissions: ["admin:manage"],
        accountType: "admin"
      },
      { 
        name: "จัดการผู้ใช้", 
        href: "/admin/users", 
        icon: Users,
        requiredPermissions: ["admin:manage", "customer:update"],
        accountType: "admin"
      },
      { 
        name: "จัดการสลิปการชำระเงิน", 
        href: "/admin/payment-slips", 
        icon: Receipt,
        requiredPermissions: ["admin:manage"],
        accountType: "admin"
      },
      { 
        name: "PromptPay อัตโนมัติ", 
        href: "/admin/reservepay-transactions", 
        icon: Zap,
        requiredPermissions: ["admin:manage"],
        accountType: "admin"
      },
      { 
        name: "ประวัติการใช้งาน API", 
        href: "/admin/api-activity", 
        icon: Activity,
        requiredPermissions: ["admin:manage"],
        accountType: "admin",
      },
      { 
        name: "รายงานระบบ", 
        href: "/admin/reports", 
        icon: FileText,
        requiredPermissions: ["admin:manage"],
        accountType: "admin",
        children: [
          {
            name: "รายได้รายเดือน",
            href: "/admin/reports/revenue",
            icon: BarChart3,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "การเติบโตของลูกค้า",
            href: "/admin/reports/customers",
            icon: Users,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "ประสิทธิภาพระบบ",
            href: "/admin/reports/performance",
            icon: Activity,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "สรุปการยืนยันสลิป",
            href: "/admin/reports/verifications",
            icon: ShieldCheck,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "เครดิตและการเรียกเก็บเงิน",
            href: "/admin/reports/credits",
            icon: CreditCard,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "เครดิตที่ใช้รายธนาคาร",
            href: "/admin/reports/bank-usage-credits",
            icon: BarChart3,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
          {
            name: "ขั้นตอน KYC",
            href: "/admin/reports/kyc",
            icon: GitBranch,
            requiredPermissions: ["admin:manage"],
            accountType: "admin",
          },
        ],
      },
    ],
  },
  {
    title: "การตั้งค่า",
    accountType: "admin",
    items: [
      { 
        name: "ตั้งค่าระบบ", 
        href: "/admin/settings/system", 
        icon: Settings,
        requiredPermissions: ["admin:manage", "system:configure"],
        accountType: "admin"
      },
      { 
        name: "ความปลอดภัย", 
        href: "/admin/settings/security", 
        icon: Shield,
        requiredPermissions: ["admin:manage", "security:configure"],
        accountType: "admin"
      },
    ],
  },
]